module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }), _vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText"
  }, [_vm._v("For our grandchildren and great-grandchildren—may you share our love for the beauty and majesty of the ocean, and for the fascinating creatures inhabiting those waters.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6344eac3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0004.vue
// module id = 69
// module chunks = 0